export const colors = {
    primColorLight: "#247b83",
    primColor: "#006064",
    primColorDark: "#114c4d",
    primColorDarker: "#00363a",
    tableEvenRow: "#d3d7db",
    tableOddRow: "#bec8d1",
    editIcon: "#0fb7fa",
    deleteIcon: "red"
};